import { useContext } from 'react';
import { A } from 't-lib-ui/widgets';
import { AppState } from '../context/general';
import DownreadLogo from './DownreadLogo';
import './ShareHeader.css';

const ShareHeader: React.FC = () => {
  const appState = useContext(AppState);
  const isLoggedIn = appState.state.loginState == 'ok';
  // Anonymous readers who already follow at least one feed (kept in localStorage) have a populated
  // reader to return to, so treat them like signed-in users for the header CTA.
  const hasAnonFeeds = (() => {
    if (isLoggedIn || typeof localStorage == 'undefined') return false;
    try {
      return (JSON.parse(localStorage.getItem('anon-feeds') || '[]') as string[]).length > 0;
    } catch {
      return false;
    }
  })();
  const hasReader = isLoggedIn || hasAnonFeeds;
  const logoSize = 28;
  const logoTextBaselineOffsetPx = (logoSize * 25) / 200;

  return (
    <header className="shareHeader">
      <a
        href="https://downread.com"
        className="shareHeaderLeft"
        style={{ '--logo-text-baseline-offset': `${Math.ceil(logoTextBaselineOffsetPx)}px` } as React.CSSProperties}
      >
        <span className="shareHeaderLogoWrap">
          <DownreadLogo size={logoSize} showText />
        </span>
        <span className="shareHeaderTagline">Your personal feed reader</span>
      </a>
      <div className="shareHeaderRight">
        {hasReader ? (
          <A href="/a" internal className="shareHeaderBtn primary">To my feeds</A>
        ) : (
          <A href="/login" internal className="shareHeaderBtn secondary">Log in</A>
        )}
      </div>
    </header>
  );
};

export default ShareHeader;
